import type { ProjectAssignButtonProps } from "./project-assign-button.type";

import { ModelAssignButton } from "@/modules/model-assign";

import { ProjectAssignForm } from "../project-assign-form";

export const ProjectAssignButton = ({
  project,
  options,
  ...buttonProps
}: ProjectAssignButtonProps) => {
  return (
    <ModelAssignButton
      item={project}
      form={<ProjectAssignForm project={project} options={options} />}
      {...buttonProps}
    />
  );
};
